<template>
  <div class="c-globalAlert">
    <component class="c-globalAlert_component" :is="activeAlert" />
  </div>
</template>

<script lang="ts">
import Vue, { PropOptions, VueConstructor } from 'vue'
import { mapState, mapActions } from 'vuex'
import companyStatusType from 'Enums/companyStatusType'
import { StoreState } from 'Types'
import { openModal } from 'Services/vueModal'
import { parse as parseUrl } from 'url'
const modalResearch = () => import('Components/Global/Research/modalResearch')

const initialState = () => ({
  url: parseUrl(location.href)
})

export default Vue.extend({

  async mounted() {
    const { pathname } = parseUrl(location.href)

    const isNegotiationPage = pathname === '/negociacoes'

    if (this.isAuthenticated && this.company.isActive && isNegotiationPage) {

      this.getDisplay().then((res)=>{
        if(res) {
          this.openResearchModal()
        }
      })

    }

    if(this.isAuthenticated) {
      await this.getStatusTokenTWoFactorAuth()
      
      if(this.company.id != null) {
        await this.getStatus()
      }
    }
  },

  data() {
    return initialState()
  },

  computed: {
    ...mapState({
      isAuthenticated: (state: StoreState) => state.account.authenticated,
      company: (state: StoreState) => state.account.company,
      info: (state: StoreState) => state.companyAccount.account.info,
      status: (state: StoreState) => state.account.twoFactorAuth.status,
      display: (state: StoreState) => state.research.display,
      companyStatus: (state: StoreState) => state.companyAccount.account.companyStatus,
    }),


    activeAlert() {

      const ignoreRoute = [
        "negociacoes",
        "checkout"
      ];

      const hideAlert = ignoreRoute
          .some(x => this.url.path.includes(x));

      if (hideAlert) {
        return null;
      }

      const {
         companyIncompleteCheckout, 
         companyHasOverdueInvoice, 
         companyUnableCompleteSubscription, 
         downgradedPlan 
      } = companyStatusType

      const alertsArray = []

      alertsArray[companyIncompleteCheckout] = () => import('Components/Global/Alert/companyNotCompleteCheckout.vue')
      alertsArray[companyHasOverdueInvoice] = () => import('Components/Global/Alert/invoiceOverdue.vue')
      alertsArray[companyUnableCompleteSubscription] = () => import('Components/Global/Alert/companyUnableCompleteSubscription.vue')
      alertsArray[downgradedPlan] = () => import('Components/Global/Alert/downgradedPlan.vue')
    
      return alertsArray[this.companyStatus] || null
    },
  },

  methods: {
    ...mapActions({
      //getCompanyPaymentStatus: 'companyAccount/subscription/getCompanyPaymentStatus',
      getStatusTokenTWoFactorAuth: 'account/getStatusTokenTWoFactorAuth',
      getDisplay: 'research/getDisplay',
      getStatus: 'companyAccount/account/getStatus'
    }),


    openResearchModal() {
      const params = { width: 650 }
      openModal(this, modalResearch, { params })
    },

  }
})
</script>

<style lang="scss">
@import "~css/_references";

.c-globalAlert {
  display: flex;
  align-content: center;
  justify-content: flex-end;
  margin: 0 auto;
  position: relative;

  &_component {
    z-index: 2;
  }
}
</style>